import React from 'react';
import ReportGmailerrorredIcon from '@mui/icons-material/ReportGmailerrorred';

const Error500 = () => {
    return (
        <div className='container'>
            <div className='inner_container'>
                <div style={{margin:'20rem auto',textAlign: 'center', }}>
                        <ReportGmailerrorredIcon sx={{fontSize:'120px', color: '#eee'}} />
                        <h1 style={{margin:'20px 0', color:'#222'}}>500 Interver Server Error</h1>
                        <p style={{whiteSpace: 'pre-line', lineHeight:'21px',color:" #777"}}>
                            {`찾으려는 페이지의 주소가 잘못 입력되었거나, 
                            주소의 변경 혹은 삭제로 인해 사용하실 수 없습니다.
                            입력하신 페이지의 주소가 정확한지 다시 한번 확인해 주세요.`}
                        </p>
                </div>
            </div>
        </div>
    );
};

export default Error500;